import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { EventTypeComponent } from './components/event-type.component';
import { EventTypeRoutingModule } from './event-type-routing.module';

@NgModule({
  declarations: [EventTypeComponent],
  imports: [
    EventTypeRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule
  ],
})
export class EventTypeModule {}

export function loadEventTypeModuleAsChild() {
  return Promise.resolve(EventTypeModule);
}
